var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2029 24.8134H23.5804V35.0134C23.5804 36.5151 25.4504 37.2234 26.4421 36.0901L37.1663 23.9067C38.1013 22.8442 37.3504 21.1867 35.9338 21.1867H31.5563V10.9867C31.5563 9.48508 29.6863 8.77675 28.6946 9.91008L17.9704 22.0934C17.0496 23.1559 17.8004 24.8134 19.2029 24.8134Z",
    fill: "url(#paint0_linear_3197_4577)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0417 12.7295H8.125C7.54417 12.7295 7.0625 12.2478 7.0625 11.667C7.0625 11.0862 7.54417 10.6045 8.125 10.6045H18.0417C18.6225 10.6045 19.1042 11.0862 19.1042 11.667C19.1042 12.2478 18.6225 12.7295 18.0417 12.7295Z",
    fill: "url(#paint1_linear_3197_4577)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 35.3955H8.125C7.54417 35.3955 7.0625 34.9138 7.0625 34.333C7.0625 33.7522 7.54417 33.2705 8.125 33.2705H16.625C17.2058 33.2705 17.6875 33.7522 17.6875 34.333C17.6875 34.9138 17.2058 35.3955 16.625 35.3955Z",
    fill: "url(#paint2_linear_3197_4577)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 24.0625H8.125C7.54417 24.0625 7.0625 23.5808 7.0625 23C7.0625 22.4192 7.54417 21.9375 8.125 21.9375H12.375C12.9558 21.9375 13.4375 22.4192 13.4375 23C13.4375 23.5808 12.9558 24.0625 12.375 24.0625Z",
    fill: "url(#paint3_linear_3197_4577)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3197_4577",
    x1: 27.5728,
    y1: 9.35156,
    x2: 27.5728,
    y2: 36.6486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3197_4577",
    x1: 13.0833,
    y1: 10.6045,
    x2: 13.0833,
    y2: 12.7295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3197_4577",
    x1: 12.375,
    y1: 33.2705,
    x2: 12.375,
    y2: 35.3955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3197_4577",
    x1: 10.25,
    y1: 21.9375,
    x2: 10.25,
    y2: 24.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapEnergyIcon);
export default __webpack_public_path__ + "static/media/map-energy-icon.69f78e325a246cd4dc28fd0146d393a0.svg";
export { ForwardRef as ReactComponent };